<template>
  <v-container class="pa-0 border">
    <v-data-table
      :headers="headers"
      :items="items"
      class="border ma-12"
      density="compact"
      hide-default-header
      hide-default-footer
      :style="{
        backgroundColor: PAYMENT_CERTIFICATE_TABLE_COLOR.BLUE,
      }"
    >
      <template
        v-slot:[`item.${header.value}`]="{ item }"
        v-for="header in headers"
      >
        <div :key="`${item.id}-${header.value}`">
          {{ formatValue(item[header.value]) }}
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { formatValue, PAYMENT_CERTIFICATE_TABLE_COLOR } from '@/helpers'
export default {
  props: {
    headers: Array,
    items: Array
  },
  data () {
    return {
      formatValue,
      PAYMENT_CERTIFICATE_TABLE_COLOR
    }
  }
}
</script>
